import { useCallback, useState } from 'react';
import { ApolloError, ServerError } from '@apollo/client';
import { ClientError, ErrorResult } from '@cobra/fe-lib/client-error-handling/classes/ClientError';

export const useErrorHandling = <TErrorResult extends ErrorResult = ErrorResult>() => {
    const [error, setError] = useState<ClientError<TErrorResult> | undefined>();

    const mapNetworkError = useCallback((error: ServerError) => {
        setError(new ClientError(error.result as TErrorResult));
    }, []);

    const mapDefaultError = useCallback(() => {
        setError(new ClientError());
    }, []);

    const handleError = useCallback(
        (error: ApolloError | undefined) => {
            if (error?.networkError) {
                mapNetworkError(error.networkError as ServerError);
            } else {
                mapDefaultError();
            }
        },
        [mapNetworkError, mapDefaultError]
    );

    const resetError = useCallback(() => {
        setError(undefined);
    }, []);

    return {
        error,
        setError,
        handleError,
        resetError,
    };
};
